/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { AutoTestStepBaseInputAsJSON } from './AutoTestStepBaseInputAsJSON';
import { CodeQualityExtra } from './CodeQualityExtra';
const CodeQualityInputAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(CodeQualityExtra, AutoTestStepBaseInputAsJSON);
export class CodeQualityInputAsJSON extends AutoTestStepBaseInputAsJSON {
    static decode(input) {
        return CodeQualityInputAsJSONParser.decode(input).map(res => new CodeQualityInputAsJSON(res));
    }
    static unsafeDecode(input) {
        return CodeQualityInputAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CodeQualityInputAsJSONParser.encode(data);
    }
    static schema() {
        return CodeQualityInputAsJSONParser.schema();
    }
}
